import { Outlet } from "react-router";

export { ErrorPage as ErrorBoundary } from "../../src/pages/marketing/ErrorPages";

/**
 * Pathless layout that exists only to carry the page-content error boundary:
 * page failures render inside the shared chrome (nav + footer remain).
 */
export default function PageContentBoundary() {
  return <Outlet />;
}
